// Oyun penceresinin hata ekranında başlık ve metin tek yerden çözülür.
//
// Oyuncuya teknik sebep **yazılmaz**: sağlayıcının ve kurulumun kendi
// diliyle yazılmış metinler ("… callback URL set edilmemiş. Hub → API
// Ayarları → …") backend'de günlüğe alınır ve yerine sabit bir sistem
// hatası döner (backend/services/launch_failure.py). Burada kalan tek iş,
// sunucunun hiç cevap veremediği hâli oyuncunun anlayacağı bir cümleye
// çevirmektir.
const DEFAULT_TITLE = 'Oyun başlatılamadı';
const UNREACHABLE_TEXT = 'Sunucuya şu anda ulaşılamıyor, biraz sonra tekrar deneyin';

// Cloudflare origin'in 502/504 cevabını kendi JSON'uyla değiştirir ve
// `detail` alanına İngilizce bir metin yazar ("The origin web server returned
// an invalid or incomplete response to Cloudflare…"). Backend bunu kullanıcı
// yollarında önler (server._shield_upstream_error), ama sunucu gerçekten
// yanıt vermediğinde metin yine gelir; oyuncuya o hâliyle gösterilmez.
function isEdgeText(text) {
  return /cloudflare/i.test(text);
}

export function launchErrorParts(message) {
  const text = String(message || '').trim();
  if (isEdgeText(text)) {
    return { title: DEFAULT_TITLE, text: UNREACHABLE_TEXT };
  }
  return { title: DEFAULT_TITLE, text };
}
